import TeamDashboard from '../pages/TeamDashboard';

const teamDashboardRoute = {
  public: [],
  auth: [
    {
      name: 'team_dashboard',
      path: '/dashboard/team',
      component: TeamDashboard,
      permissions: ['admin', 'COO', 'EXECUTIVE'],
    },
  ],
};

export default teamDashboardRoute;
